import { Placeholder, PlaceholderProps } from "reactstrap";

interface AnimatedPlaceholderProps extends PlaceholderProps {
  loading?: boolean;
  children?: React.ReactNode; // loaded content
}

const AnimatedPlaceholder = (props: AnimatedPlaceholderProps) => {
  const { loading = true, children, animation = "glow", tag, ...placeholderProps } = props;

  return (loading ?
    <Placeholder animation={animation} tag={tag}>
      <Placeholder {...placeholderProps} />
    </Placeholder>
    : <>{children}</>
  );
}

export default AnimatedPlaceholder;
